import { cva } from "class-variance-authority";

export const dropdownMenuContentVariants = cva([
  "bg-base-100 text-base-content z-50 min-w-32 overflow-x-hidden overflow-y-auto rounded-xl shadow-lg",
  "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
]);
export const dropdownMenuItemVariants = cva(
  "data-[highlighted]:bg-accent [&_svg]:opacity-muted data-[disabled]:opacity-disabled flex w-full items-center gap-2 p-2 pe-3 text-sm ring-0 select-none data-[disabled]:pointer-events-none [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
);
export const dropdownMenuLabelVariants = cva("px-2 py-1.5 text-sm font-medium");
export const dropdownMenuSeparatorVariants = cva(
  "bg-border-base pointer-events-none -mx-1 my-1 h-px",
);
